const initialState = {
  planIds: null,
  planParams: null,
  planData: null,
  currentPlanId: null,
  selectedPlanId: null,
  selectedTeamId: 'all',
  initForm: false
}
const plans = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_PLANS': 
      let planIds = []
      let planParams = {}
      let currentPlanId = state.currentPlanId
      let selectedPlanId = state.selectedPlanId
      action.snapshot.docs.forEach(doc => {
        planIds.push(doc.id)
        planParams[doc.id] = doc.data()
        if(doc.data().current){
          currentPlanId = doc.id
        }
        if(doc.data().current && selectedPlanId === null){
          selectedPlanId = doc.id
        }
      })
      return {
        ...state,
        planIds: planIds.length === 0 ? null : planIds,
        planParams: planParams.length === 0 ? null : planParams,
        currentPlanId,
        selectedPlanId
      }

    case 'LOAD_PLAN_DATA': 
      let planData = state.planData? state.planData : {}
      planData[action.planId] = {}
      action.snapshot.docs.forEach(doc => {
        planData[action.planId][doc.id] = doc.data()
      })
      return {
        ...state,
        planData
      }

    case 'CHANGE_PLAN_ID':
      return {
        ...state,
        selectedPlanId: action.planId
      }

    case 'CHANGE_PLANNING_TEAM':
      return {
        ...state,
        selectedTeamId: action.teamId
      }
    
    case 'CHANGE_PLANNING_FORM_INIT_STATUS':
      return {
        ...state,
        initForm: action.status
      }

    default: 
      return state
  }
}
export default plans



// WEBPACK FOOTER //
// ./src/reducers/plans.js